import {
  LoginSuccessParams,
  SignupSuccessParams,
  LoginSuccessWithLineParams,
} from '@common/types/';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';

type StateAuth = {
  token: any;
  profile: any;
  isAuth: boolean;
  isOAuth: boolean;
  loading: boolean;
  screenId: any;
  friendship?: boolean;
};

const initialState: StateAuth = {
  token: null,
  profile: null,
  isAuth: false,
  isOAuth: false,
  loading: false,
  screenId: null,
  friendship: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    checkAuth: (state: StateAuth, action: PayloadAction<any>) => {
      const user = action.payload;
      if (user) {
        state.profile = user;
        state.isAuth = true;
      } else {
        state.isAuth = false;
        state.profile = null;
      }
    },
    checkAuthError: (state: StateAuth) => {
      state.profile = null;
      state.isAuth = false;
    },
    loginSuccess: (
      state: StateAuth,
      action: PayloadAction<LoginSuccessParams>
    ) => {
      const { user } = action.payload;
      state.profile = user;
      state.isAuth = true;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
    signupUserSuccess: (
      state: StateAuth,
      action: PayloadAction<SignupSuccessParams>
    ) => {
      const { user } = action.payload;
      state.profile = user;
      state.isAuth = true;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
    updateLoggedUserSuccess: (
      state: StateAuth,
      action: PayloadAction<LoginSuccessParams>
    ) => {
      const { user } = action.payload;
      state.profile = {
        ...state.profile,
        ...user,
      };
      state.isAuth = true;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
    signOut: (state: StateAuth, action: PayloadAction<any>) => {
      state.isAuth = false;
      state.profile = null;
      AsyncStorage.setItem('user', JSON.stringify({}));
    },
    loginSuccessWithLine: (
      state: StateAuth,
      action: PayloadAction<LoginSuccessWithLineParams>
    ) => {
      const { user, token, friendship } = action.payload;
      state.profile = user;
      state.isAuth = true;
      state.token = token;
      state.friendship = friendship;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
    loginSuccessWithOAuth: (
      state: StateAuth,
      action: PayloadAction<LoginSuccessWithLineParams>
    ) => {
      const { user, token } = action.payload;
      state.profile = user;
      state.isAuth = true;
      state.isOAuth = true;
      state.token = token;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
    loginSuccessWithApple: (state: StateAuth, action: PayloadAction<any>) => {
      const { user, token } = action.payload;
      state.profile = user;
      state.isAuth = true;
      state.isOAuth = true;
      state.token = token;
      AsyncStorage.setItem('user', JSON.stringify(user));
    },
  },
});

export const {
  signOut,
  checkAuth,
  loginSuccess,
  checkAuthError,
  signupUserSuccess,
  updateLoggedUserSuccess,
  loginSuccessWithLine,
  loginSuccessWithOAuth,
  loginSuccessWithApple,
} = authSlice.actions;
export default authSlice.reducer;
